import React, { ReactNode } from 'react';

import { DateValue } from '@internationalized/date';
import { useAtom } from 'jotai';

import {
  useAccountInfo,
  usePaymentCalendarDates,
} from '@consumer-frontend/nc-api';
import {
  PAYMENT_METHODS,
  PaymentMethodT,
  today,
} from '@consumer-frontend/nc-utils';

import { accountIdAtom } from '../../store';
import { NcDatePicker } from '../NcDatePicker';

import '@consumer-bootstrap/netcredit.scss';
// eslint-disable-next-line import/order
import '@consumer-bootstrap/brands/netcredit/payment/date.scss';

export type NcPaymentDatePropsT = {
  onChange: (date: DateValue | null) => void;
  defaultValue?: DateValue;
  errorMessage?: ReactNode;
  paymentMethod?: PaymentMethodT;
  value?: DateValue;
};
export type NcPaymentDateT = React.FC<NcPaymentDatePropsT>;

export const NcPaymentDate: NcPaymentDateT = ({
  defaultValue,
  errorMessage,
  onChange,
  paymentMethod = PAYMENT_METHODS.DEBIT_CARD, // Start with debit_card to enable all dates by default
  value,
}) => {
  const [accountId] = useAtom(accountIdAtom);
  const { accountInfo: { loanNumber } = {} } = useAccountInfo(accountId);

  const { paymentCalendarDates } = usePaymentCalendarDates(
    accountId,
    loanNumber,
    paymentMethod,
  );
  const {
    invalidDates = [],
    maxDate,
    minDate: minDateFromApi,
  } = paymentCalendarDates || {};

  const minDate = minDateFromApi || (paymentMethod === PAYMENT_METHODS.DEBIT_CARD ? today() : today().add({ days: 1 }));

  return (
    <div className="nc-payment-date">
      <NcDatePicker
        defaultValue={value || defaultValue}
        disabledDates={invalidDates}
        errorMessage={errorMessage}
        id="payment-date"
        label="Payment Date"
        max={maxDate || undefined}
        min={minDate || today()}
        onChange={onChange}
      />
    </div>
  );
};
